import { render, staticRenderFns } from "./EmailAuthenticationPane.vue?vue&type=template&id=397ff5aa&scoped=true"
import script from "./EmailAuthenticationPane.vue?vue&type=script&lang=ts"
export * from "./EmailAuthenticationPane.vue?vue&type=script&lang=ts"
import style0 from "./EmailAuthenticationPane.vue?vue&type=style&index=0&id=397ff5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ff5aa",
  null
  
)

export default component.exports